import React from 'react';

/**
 * The thumbs up / down mark, in the brand ember: an outline at rest, filled
 * when it is the chosen answer. One glyph for every place a person says
 * good or bad, so it never drifts to a default icon-set colour.
 */
export default function ThumbIcon({ direction = 'up', filled = false, size = 14, className, style }) {
  const down = direction === 'down';
  return (
    <svg
      width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false"
      fill={filled ? 'var(--trodo-primary)' : 'none'} stroke="var(--trodo-primary)"
      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      className={className} style={{ flex: 'none', ...style }}
    >
      <g transform={down ? 'translate(0 24) scale(1 -1)' : undefined}>
        <path d="M7 10v12" />
        <path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z" />
      </g>
    </svg>
  );
}
